'use client';
import {Link} from "@/i18n/routing";
import logoImage from "@/assets/img/logo.webp";
import { useWishlistContext } from "@/providers/WshlistContext";
import { useCartContext } from "@/providers/CartContext";
import {useTranslations} from 'next-intl';
import {useCommonDataContext} from '@/providers/CommonDataContext';
import LogoImage from '@/components/layout/headers/LogoImage';
import {PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';
import Form from 'next/form';
import {useUserContext} from '@/providers/UserContext';

export default function MobileMenuWrapper({ id, children, home, socialLinks= [] }) {
  const t = useTranslations('header');
  const { common } = useCommonDataContext();
  
  const { wishlistProducts } = useWishlistContext();
  const { cartProducts } = useCartContext();
  const { user } = useUserContext();
  const totalCartProduct = cartProducts?.length ?? 0;
  const totalWishlistProduct = wishlistProducts?.length ?? 0;
  
  return (
    <div
      id={`ltn__utilize-mobile-${id}`}
      className="ltn__utilize ltn__utilize-mobile-menu"
    >
      <div className="ltn__utilize-menu-inner ltn__scrollbar">
        <div className="ltn__utilize-menu-head">
          <LogoImage logoSrc={home?.primaryShopLogo ?? common?.home?.primaryShopLogo ?? logoImage} mobile/>
          <button className="ltn__utilize-close">×</button>
        </div>
        <div className="ltn__utilize-menu-search-form">
          <Form action="/catalog">
            <input
                type="text"
                name="search"
                placeholder={t('search')}
            />
            <button type="submit">
              <span>
                <i className="icon-search"></i>
              </span>
            </button>
          </Form>
        </div>
        {children}
        {
          id === 'menu' ? (
              <div className="ltn__utilize-buttons ltn__utilize-buttons-2 d-flex justify-content-around">
                <Link href={PRIVATE_ROUTE_NAME} title={t('account.myAccount')}>
                  <span className="utilize-btn-icon">
                    <i className="fas fa-user"></i>
                  </span>
                  {/*{t('account.myAccount')}*/}
                </Link>
                <Link href={user ? `${PRIVATE_ROUTE_NAME}?tab=wishlist` : '/wishlist'} title={t('account.wishlist')}>
                  <span className="utilize-btn-icon">
                    <i className="fas fa-heart"></i>{' '}
                    <sup>{totalWishlistProduct}</sup>
                  </span>
                  {/*{t('account.wishlist')}*/}
                </Link>
                <Link href={user ? `${PRIVATE_ROUTE_NAME}?tab=cart` : '/cart'} title={t('account.shoppingCart')}>
                  <span className="utilize-btn-icon">
                    <i className="fas fa-shopping-cart"></i>{' '}
                    <sup>{totalCartProduct}</sup>
                  </span>
                  {/*{t('account.shoppingCart')}*/}
                </Link>
              </div>
          ) : (<div style={{height: 20}}></div>)
        }
        {
          Array.isArray(socialLinks) && socialLinks.length > 0
              ? (
                  <div className="ltn__social-media-2">
                    <ul>
                      {
                        socialLinks.map((item, i) => (
                            <li key={i}>
                              <Link
                                  href={item.url}
                                  title={item.title}
                                  target="_blank"
                              >
                                <i className={item.icon}></i>
                              </Link>
                            </li>
                        ))
                      }
                    </ul>
                  </div>
              ) : Array.isArray(common?.socialLinks) && common?.socialLinks?.length > 0
                  ? (
                      <div className="ltn__social-media-2">
                        <ul>
                        {
                            common?.socialLinks.map((item, i) => (
                                <li key={i}>
                                  <Link
                                      href={item.url}
                                      title={item.title}
                                      target="_blank"
                                  >
                                    <i className={item.icon}></i>
                                  </Link>
                                </li>
                            ))
                          }
                        </ul>
                      </div>
                  ) : ''
        }
      </div>
    </div>
  );
};
